import { setWasmUrl } from '@lottiefiles/dotlottie-wc';
import '@lottiefiles/dotlottie-wc';

setWasmUrl('/public/js/shared/dotlottie-player.wasm');
